// @flow
export const customErrorMessage = (messageError: string) => {
  if (messageError === 'Cannot delete the only pick up address left') {
    return 'No se puede eliminar la única dirección de recogida que queda';
  }

  if (messageError === 'You must have at least one enabled standard method') {
    return 'Debes tener al menos un método estándar habilitado';
  }

  if (messageError === 'You must have at least one flat rate activated') {
    return 'Debes tener al menos un método manual habilitado';
  }

  if (messageError === 'Cannot delete the only admin group left') {
    return 'Debes tener al menos un método avanzado habilitado';
  }

  if (messageError === 'Cannot delete the only flat rate left') {
    return 'No se puede eliminar el único método manual que queda';
  }

  if (
    messageError === 'You must have at least one standard method configured'
  ) {
    return 'Debes tener al menos un método estándar configurado';
  }

  if (messageError === 'You must have at least one enabled flat rate') {
    return 'Debes tener al menos un método manual habilitado';
  }

  if (messageError === 'You must have at least one enabled admin group') {
    return 'Debes tener al menos un método avanzado habilitado';
  }

  if (messageError === 'Cannot delete the only standard method left') {
    return 'No se puede eliminar el único método estándar que queda';
  }

  if (messageError === 'You must have at least one address activated') {
    return 'Debes tener al menos una dirección habilitada';
  }

  return 'Ocurrió un error al guardar la configuración';
};
